module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0118.jpg?v=065dd286";